module.exports = __webpack_public_path__ + "img/about_banner.6d1297bd.png";